import type { Plan } from '@/core/domain';
import type { PlanRepository } from '../repositories/plan-repository';

export class GetPlanByIdUseCase {
  constructor(private readonly repository: PlanRepository) {}

  async execute(id: string): Promise<Plan | null> {
    return this.repository.getById(id);
  }
}
